<template>
  <div class="GdPage">
    <div class="back" @click="goBack()">
      <div class="backIcon">
        <img src="../../assets/images/workOrderReview/back.png" alt="">
      </div>
      <div class="backText">{{$t('lang.UploadProof.backText')}}</div>
    </div>
    <div class="listView">
      <div class="title">{{$t('lang.UploadProofDetail.DisputedBill')}}:</div>
      <div class="detailBox" v-if="DetailShowType ==='0'">
        <div class="row1">
          <div class="leftBox">
            <img src="../../assets/images/workOrderReview/wallet.png" alt="">
            <div class="typeTitle">{{$t('lang.UploadProofDetail.TypeTitle')}}</div>
          </div>
          <div class="rightBox" @click="goBack">
            <span> {{$t('lang.UploadProofDetail.ReSelect')}}</span> &nbsp;>
          </div>
        </div>
        <div class="lableRow">
          <div class="label">{{$t('lang.UploadProofDetail.Amount')}}:</div>
          <div class="value">₹{{TransactionData.Amount}}</div>
        </div>
        <div class="lableRow">
          <div class="label">{{$t('lang.UploadProofDetail.GenerationTime')}}:</div>
          <div class="value">{{TransactionData.TransactionDate}}</div>
        </div>
        <div class="lableRow">
          <div class="label">{{$t('lang.UploadProofDetail.BillNumber')}}:</div>
          <div class="value">{{TransactionData.TransactionUuid}}</div>
        </div>
<!--        <div class="detailBoxTip">-->
<!--          {{$t('lang.UploadProofDetail.detailBoxTip')}}-->
<!--        </div>-->

      </div>
      <div class="detailBox1" v-if="DetailShowType!=='0'">
        <div class="row1">
          <div class="leftBox">
            <div class="typeTitle" style="margin-left: 3vw">{{$t('lang.UploadProofDetail.BillNumber')}}:<span>{{TransactionData.TransactionUuid}}</span></div>
          </div>
          <div class="rightBox">
            <span  v-if="TransactionData.TicketStatus === 0">{{$t('lang.workOrderReview.Pending')}}</span>
            <span v-if="TransactionData.TicketStatus === 1 || TransactionData.TicketStatus === 2">{{$t('lang.workOrderReview.Completed')}}</span>
<!--            <span> {{$t('lang.UploadProofDetail.ReSelect')}}</span> &nbsp;>-->
          </div>
        </div>
        <div class="lableRow">
          <div class="label">{{$t('lang.UploadProofDetail.Amount')}}:</div>
          <div class="value">₹{{TransactionData.Amount}}</div>
        </div>
        <div class="lableRow">
          <div class="label">{{$t('lang.UploadProofDetail.GenerationTime')}}:</div>
          <div class="value">{{TransactionData.UpdateTime}}</div>
        </div>
        <div class="lableRow">
          <div class="label">{{$t('lang.UploadProofDetail.issue')}}:</div>
          <div class="value">{{TransactionData.Issue}}</div>
        </div>
                <div class="detailBoxTip" v-if="!(MessageIsOpen || (!MessageIsOpen && chatList.length!==0))">
                  {{$t('lang.UploadProofDetail.detailBoxTip')}}
                </div>
        <div :class="Expand?'detailBoxTip1Extend':'detailBoxTip1'" v-else>
          <div  class="tipLine"></div>
          <div  class="expandText" @click="Expand = !Expand"> {{$t('lang.UploadProofDetail.ExpandView')}}</div>
          <img  src="../../assets/images/workOrderReview/extendIcon.png" alt="">
          <div  class="tipLine1"></div>
<!--          <div v-if="!isChat" style="margin-right: 3vw" class="expandText2" @click="Expand = !Expand">{{$t('lang.UploadProofDetail.detailBoxTip')}}</div>-->
        </div>
      </div>
      <div :class="Expand?'expandBox':'expandBoxExtend'">
        <div class="questionTip">{{$t('lang.UploadProofDetail.WPDYE')}}</div>
        <div style="position: relative">
            <div class="maxInputNum">{{Issue.length}}/60</div>
          <input :disabled="DetailShowType==='1' || DetailShowType === '2'" v-model="Issue" @input="filterChineseCharactersIssue" type="text" maxlength="60" :placeholder="$t('lang.UploadProofDetail.problemDescribe')"  :class="(DetailShowType==='1' || DetailShowType === '2')?'problemInputNone':'problemInput'"/>
        </div>
        <div class="questionTip">{{$t('lang.UploadProofDetail.PV')}}:</div>
        <div class="fileTip">{{$t('lang.UploadProofDetail.TSOABWR')}}</div>
        <div class="fileBox">
          <imageUpload :disabled="DetailShowType==='1' || DetailShowType === '2'" :defaultFile="defaultFile" ref="imgUpload" @getImage="getImage"></imageUpload>
        </div>
        <div v-if="TransactionData.GatewayType === 'USDT'" class="questionTip">{{$t('lang.UploadProofDetail.HASH')}}</div>
        <div v-else class="questionTip">{{$t('lang.UploadProofDetail.PU')}}</div>
        <input v-if="TransactionData.GatewayType === 'USDT'" :disabled="DetailShowType==='1' || DetailShowType === '2'" v-model="UTR"  type="text" :placeholder="$t('lang.UploadProofDetail.HashTip')"  :class="(DetailShowType==='1' || DetailShowType === '2')?'problemInputNone':'problemInput'"/>
        <input v-else :disabled="DetailShowType==='1' || DetailShowType === '2'" v-model="UTR" @input="filterChineseCharactersUTR"  type="text" :placeholder="$t('lang.UploadProofDetail.UTRIFBW')"  :class="(DetailShowType==='1' || DetailShowType === '2')?'problemInputNone':'problemInput'"/>
        <div class="formErrorTip" v-if="TransactionData.GatewayType === 'USDT' && HashInputErrorTipShow">{{$t('lang.UploadProofDetail.HashInputError')}}</div>
      </div>
      <div @click="sendData" class="btnBox"  v-if="DetailShowType==='0' && Issue && UTR && DepositVoucher">
        <div  class="next">{{$t('lang.UploadProof.Next')}}</div>
      </div>
      <div class="btnBox"  v-if=" DetailShowType==='0' && !Issue || !UTR || !DepositVoucher">
        <div  class="nextNo">{{$t('lang.UploadProof.Next')}}</div>
      </div>
      <div class="chatBox" v-if="MessageIsOpen || (!MessageIsOpen && chatList.length!==0)">
        <div class="chatList" @click="openeFileSelectBox = false">
          <div v-for="(item,index) in chatList" v-if="MessageIsOpen || (!MessageIsOpen && chatList.length!==0)" :key="index" :class="item.SenderType===0?'chatLeft':'chatRight'">
            <div v-if="item.SenderType===0">
              <img :src="officia" alt="" class="userImage">
              <div class="userInfo">
                <div class="userContent" v-if="!item.FileType" v-html="item.Message"></div>
                <div class="userContent" v-if="item.FileType==='0'">
                  <img :src="item.URL"/>
                </div>
                <div class="userContent" v-if="item.FileType==='1'" @click="openFileURL(item.URL)" style="display: flex;align-items: center">
                  <div class="fileName">{{item.Message}}</div>
                  <img class="fileIcon" src="../../assets/images/workOrderReview/addedFileMessage.png" alt="">
                </div>
              </div>
            </div>
            <div v-if="item.SenderType === 1">
              <div class="userInfo">
                <div class="userContent" v-if="!item.FileType" v-html="item.Message"></div>
                <div class="userContent" v-if="item.FileType==='0'">
                  <img :src="item.URL"/>
                </div>
                <div class="userContent" v-if="item.FileType==='1'" @click="openFileURL(item.URL)" style="display: flex;align-items: center">
                  <div class="fileName">{{item.Message}}</div>
                  <img class="fileIcon" src="../../assets/images/workOrderReview/addedFileMessage.png" alt="">
                </div>
              </div>
              <img src="../../assets/images/workOrderReview/userImage.png" alt="" class="userImage">
            </div>
          </div>
          <div class="ProofResult" v-if="resultInfo" @click="goResultPage">
            <img src="../../assets/images/workOrderReview/valume.png" alt="" class="resultIcon">
            <div class="titleBox">
              <div class="title">{{resultInfo.Title}}</div>
              <div class="time">{{formatDate(resultInfo.CreateTime)}}</div>
            </div>
            <img src="../../assets/images/workOrderReview/go.png" alt="" class="goIcon">
          </div>

        </div>
        <div>
          <div class="chatActionBox" v-if="MessageIsOpen && DetailShowType !=='0'">
            <div :class="openeFileSelectBox?'chatTodoBox':'chatTodoBox2'"></div>
            <div :class="openeFileSelectBox?'chatTodo':'chatTodo2'">
              <div class="row">
                <img class="addFile" src="../../assets/images/workOrderReview/addFile.png" alt="" @click="()=>{
                  openeFileSelectBox = !openeFileSelectBox
                }">
                <div class="chatInputBox">
                  <input v-model="messageVal" @input="filterChineseCharacters" class="chatInput" :placeholder="$t('lang.UploadProof.EnterMesageHere')" type="text">
                  <div @keydown.enter="sendMessage()"  @click="sendMessage()" class="sendBtn">{{$t('lang.UploadProof.Send')}}</div>
                </div>
              </div>

              <div class="fileSelectBox">
                <div class="fileItem" style="margin-left: 6vw">
                  <imageUpload @bottomuseGetImage="bottomuseGetImage"  class="uploadComponent"></imageUpload>
                  <img src="../../assets/images/workOrderReview/addImageBg.png" alt="">
                  <div class="fileLabel">{{$t('lang.UploadProof.Photo')}}</div>
                </div>
                <div class="fileItem">
                  <fileUpload @bottomuseGetFile="bottomuseGetFile" class="uploadComponent"></fileUpload>
                  <img src="../../assets/images/workOrderReview/addIFileBg.png" alt="">
                  <div class="fileLabel">{{$t('lang.UploadProof.File')}}</div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="messageMarsk" v-show="meassgeShow">
      <div class="messageBox">
        <div class="title">{{$t('lang.workOrderReview.WSFTL')}}</div>
        <div class="title">{{$t('lang.workOrderReview.WSFTL2')}}</div>
        <div class="content">
          {{$t('lang.workOrderReview.WSFTLContent')}}
        </div>
        <div class="actionBtnBox">
          <div class="btn"  @click="goBack">{{$t('lang.workOrderReview.Return')}}</div>
        </div>
        <div class="returnTip">
          {{$t('lang.workOrderReview.returnTip')}}
        </div>
        <div class="returnTip" style="margin-bottom: 2vw">
          {{$t('lang.workOrderReview.returnTip2')}}
        </div>
<!--        <img @click="meassgeShow = false" class="closeIcon" src="../../assets/images/workOrderReview/close.png" alt="">-->
      </div>
    </div>
  </div>
</template>

<script>
// import {Loadmore, Toast} from 'mint-ui'
import officia from '../../assets/images/workOrderReview/officia.png'
import imageUpload from '../../components/workOrderReview/imageUpload'
import fileUpload from '../../components/workOrderReview/fileUpload'
import {Toast} from 'mint-ui'
import request from '@/service'
export default {
  name: 'UploadproofDepositDetail',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.initPage()
      vm.getMessageList()
      let messageVal = JSON.parse(localStorage.getItem('messageVal'))
      let UserId = JSON.parse(localStorage.getItem('userInfo')).UserId
      if (messageVal && messageVal.UserId === UserId && (vm.TransactionData.TicketId === messageVal.TicketId)) {
        vm.messageVal = JSON.parse(localStorage.getItem('messageVal')).value
      }
    })
  },
  data () {
    return {
      officia,
      HashInputErrorTipShow: false,
      nextFinished: false,
      resultInfo: null,
      openeFileSelectBox: false,
      Expand: false,
      detail: false,
      isChat: false,
      meassgeShow: false,
      problemDescribe: '',
      messageVal: null,
      chatList: [],
      TransactionData: {},
      Issue: '',
      UTR: '',
      DepositVoucher: null,
      defaultFile: null,
      DetailShowType: null,
      MessageIsOpen: null
      // BankStatement: null,
      // BankStatementPwd: null
    }
  },
  // 提交表单
  // Expand: true,
  // detail: false,
  // isChat: false
  //
  // 查看详情(无聊天)
  // Expand: true,
  // detail: true,
  // isChat: false,
  //
  // 查看详情(有聊天)
  // Expand: false,
  // detail: true,
  // isChat: true,
  watch: {
    '$store.state.locale': function () {

    }
  },
  components: {
    // Loadmore
    imageUpload,
    fileUpload
  },
  mounted () {

  },
  methods: {
    filterChineseCharacters (event) {
      const value = event.target.value
      // 正则表达式，匹配中文字符和中文标点符号
      const chineseRegex = /[\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/g
      // 移除中文字符和中文标点符号
      this.messageVal = value.replace(chineseRegex, '')
    },
    filterChineseCharactersIssue (event) {
      const value = event.target.value
      return value
      // // 正则表达式，匹配中文字符和中文标点符号
      // const chineseRegex = /[\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/g
      // // 移除中文字符和中文标点符号
      // this.Issue = value.replace(chineseRegex, '')
    },
    filterChineseCharactersUTR (event) {
      const value = event.target.value
      // 正则表达式，移除非数字字符
      const nonDigitsRegex = /[^0-9]/g

      // 移除所有非数字字符
      const filteredValue = value.replace(nonDigitsRegex, '')
      this.UTR = filteredValue.slice(0, 12)
    },
    goResultPage () {
      sessionStorage.setItem('resultInfo', JSON.stringify(this.resultInfo))
      this.$router.push('Message')
    },
    formatDate (originalDateString) {
      if (!originalDateString) {
        return null
      }
      // 创建 Date 对象
      const date = new Date(originalDateString)
      // 从 Date 对象获取年、月、日、时、分、秒
      const year = date.getFullYear()
      // 注意，月份从 0 开始，所以要加 1
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()
      // 将月份、日期、小时、分钟和秒格式化成两位数
      const formattedMonth = month < 10 ? `0${month}` : `${month}`
      const formattedDay = day < 10 ? `0${day}` : `${day}`
      const formattedHours = hours < 10 ? `0${hours}` : `${hours}`
      const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`
      const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`
      // 返回格式化的日期时间字符串
      // return `${formattedMonth}/${formattedDay}/${year} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`
      return `${year}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    },
    openFileURL (URL) {
      window.open(URL)
    },
    bottomuseGetImage (file) {
      if (!file) {
        return false
      }
      let formData = new FormData()
      // 将文件添加到FormData对象中
      formData.append('file', file)
      request('post', 'innovation/ticket/upload', formData).then(res => {
        if (res.Code === 1) {
          this.$refs.imgUpload.clearImgInput()
          this.sendMessage(res.S3FileURL, 0)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    bottomuseGetFile (file) {
      if (!file) {
        return false
      }
      let formData = new FormData()
      // 将文件添加到FormData对象中
      formData.append('file', file)
      request('post', 'innovation/ticket/upload', formData).then(res => {
        if (res.Code === 1) {
          this.sendMessage(res.S3FileURL, 1)
        } else {
          this.$refs.imgUpload.clearImgInput()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getMessageList () {
      let data = {
        // Skip: 0,
        // Take: 60,
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        TicketId: this.TransactionData.Id ? this.TransactionData.Id : this.TransactionData.TicketId
      }
      let url = 'innovation/ticket/message/list'
      request('post', url, data, false).then(res => {
        this.chatList = res
        if (!this.MessageIsOpen && (this.DetailShowType === '1' || this.DetailShowType === '2')) {
          this.Expand = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    sendMessage (val, fileType) {
      if (val) {
        let data = {
          FileType: fileType,
          Message: val,
          UserId: JSON.parse(localStorage.getItem('userInfo')).UserId,
          TicketId: this.TransactionData.Id ? this.TransactionData.Id : this.TransactionData.TicketId
        }
        let url = 'innovation/ticket/message/create'
        request('post', url, data, false).then(res => {
          this.getMessageList()
        }).catch(err => {
          console.log(err)
        })
      } else if (this.messageVal) {
        let data = {
          Message: this.messageVal,
          UserId: JSON.parse(localStorage.getItem('userInfo')).UserId,
          TicketId: this.TransactionData.Id ? this.TransactionData.Id : this.TransactionData.TicketId
        }
        let url = 'innovation/ticket/message/create'
        request('post', url, data, false).then(res => {
          this.messageVal = null
          this.getMessageList()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    initPage () {
      this.TransactionData = JSON.parse(sessionStorage.getItem('TransactionData'))
      let DetailShowType = sessionStorage.getItem('DetailShowType')
      this.DetailShowType = DetailShowType
      if (this.DetailShowType !== '0') {
        this.Expand = false
        this.getData()
      } else {
        this.Expand = true
      }
    },
    getData () {
      if (!this.TransactionData.Id && !this.TransactionData.TicketId) {
        return
      }
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        TicketId: this.TransactionData.Id ? this.TransactionData.Id : this.TransactionData.TicketId
      }
      const url = 'innovation/ticket/detail'
      request('post', url, data, false).then(res => {
        this.TransactionData = {
          ...res
        }
        this.resultInfo = res.InnerMessage
        this.Issue = res.Issue
        this.UTR = res.UTR
        this.DepositVoucher = res.DepositVoucher
        this.defaultFile = res.DepositVoucher
        this.MessageIsOpen = res.MessageIsOpen
        if (!res.MessageIsOpen && this.DetailShowType === '1') {
          this.Expand = true
          this.detail = true
          this.isChat = false
        } else if (res.MessageIsOpen) {
          // this.Expand = true
          this.detail = true
          this.isChat = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    sendData () {
      if (this.TransactionData.GatewayType === 'USDT' && !/^[0-9a-fA-F]{64}$/.test(this.UTR)) {
        this.HashInputErrorTipShow = true
        return
      } else {
        this.HashInputErrorTipShow = false
      }
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        ...this.TransactionData,
        Issue: this.Issue,
        TicketType: this.TransactionData.Type,
        // UTR: null,
        // DepositVoucher: null,
        UTR: this.UTR,
        DepositVoucher: this.DepositVoucher
      }
      const url = '/innovation/ticket/create'
      request('post', url, data, false).then(res => {
        if (res.Code === 0) {
          this.nextFinished = true
          this.meassgeShow = true
          this.Issue = ''
          this.DepositVoucher = null
          this.UTR = null
          this.$refs.imgUpload.clearImgInput()
        } else {
          Toast(res.Message)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getImage (file) {
      if (!file) {
        return false
      }
      let formData = new FormData()
      // 将文件添加到FormData对象中
      formData.append('file', file)
      request('post', 'innovation/ticket/upload', formData).then(res => {
        if (res) {
          this.DepositVoucher = res.S3FileURL
        } else {
          this.$refs.imgUpload.clearImgInput()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    goBack () {
      this.$refs.imgUpload.clearImgInput()
      this.TransactionData = {}
      this.Issue = ''
      this.UTR = null
      this.DepositVoucher = null
      this.defaultFile = null
      this.meassgeShow = false
      this.openeFileSelectBox = false
      localStorage.setItem('messageVal', JSON.stringify({
        value: this.messageVal,
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        TicketId: this.TransactionData.TicketId || this.TransactionData.Id
      }))
      if (!this.messageVal) {
        localStorage.removeItem('messageVal')
      }
      if (this.nextFinished) {
        this.nextFinished = false
        this.$router.push('workOrderReview')
      } else {
        this.$router.back()
      }
    },
    goto (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less" scoped>
/* 通用样式 */
input::placeholder {
  color: rgb(95,95,95);
  opacity: 1; /* 可选：设置placeholder文本的不透明度 */
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-input-placeholder {
  color: #464646;
}
.GdPage {
  position: relative;
  top: -10px;
  height: 100vh;
  overflow-y: auto;
  .back{
    height: 6.11vw;
    display: flex;
    align-items: center;
    margin-top: 22vw;

    .backIcon{
      margin-left: 5vw;

    }
    .backText{
      margin-left: 5vw;
      color: #F6D9AA;
      font-weight: 700;
      font-size: 5.27vw;
    }
  }

  .listView{
    margin-top: 6vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
    height: max-content;
    .title{
      font-size: 3.888vw;
      color: #FFFFFF;
      font-weight: bold;
      //border: 1px solid red;
      width: 91.077vw;
      margin-bottom: 2vw;
    }
    .detailBox{
      width: 91.077vw;
      height: 31.666vw;
      border-radius: 3.166vw;
      background: #222222;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .row1{
        display: flex;
        justify-content: space-between;
        .leftBox{
          display: flex;
          align-items: center;
          font-size: 4.166vw;
          color: #fff;
          font-weight: 700;
          img{
            margin-left: 3vw;
          }
          .typeTitle{
            margin-left: 1vw;
          }
        }
        .rightBox{
          display: flex;
          align-items: center;
          color: #02A7F0;
          margin-right: 3vw;
          font-size: 3.611vw;
          span{
            border-bottom: 1px solid;
          }

        }
      }
      .detailBoxTip{
        text-align: center;
        font-size: 2.77vw;
        color: #F6D9AA;
        border-top: 1px solid #5A5A5A;
        padding: 1vw;
      }
     .lableRow{
       margin-left: 3vw;
       font-size: 3.611vw;
       display: flex;
       .label{
         color: rgb(121,121,121);
         width: 29.72vw;
         font-weight: bold;
       }
       .value{
         margin-left: 2vw;
         color: #fff;
       }
     }
    }
    .detailBox1{
      width: 91.077vw;
      height: 42.555vw;
      border-radius: 3.166vw;
      background: #222222;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .row1{
        display: flex;
        justify-content: space-between;
        .leftBox{
          display: flex;
          //align-items: center;
          font-size: 3.888vw;
          color: #fff;
          font-weight: 700;
          img{
            margin-left: 3vw;
          }
          .typeTitle{
            margin-left: 3vw;
            display: flex;
            span{
              margin-left: 1vw;
              display: inline-block;
              //border: 1px solid red;
              width: 45vw;
              overflow-wrap: break-word;
            }
          }
        }
        .rightBox{
          display: flex;
          align-items: center;
          justify-content: center;
          height: auto;
          color: #000;
          background-color: #F6D9AA;
          border-radius: 0.83vw;
          margin-right: 3vw;
          font-size: 3.05vw;
          height: 5.44vw;
          width: 15.72vw;
          //width: 14.72vw;
          //padding: 0.5vw 3vw;
        }
      }
      .detailBoxTip{
        text-align: center;
        font-size: 2.77vw;
        color: #F6D9AA;
        border-top: 1px solid #5A5A5A;
        margin:0 2vw;
        padding-top: 2vw;
      }
      .detailBoxTip1{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 2.77vw;
        color: #F6D9AA;
        //border-top: 1px solid #5A5A5A;
        //padding-top: 2vw;
        .tipLine{
          height: 1px;
          background-color: #F6D9AA;
          width: 30%;
        }
        .expandText{
          margin-left:3vw;
        }
        .expandText2{
          width: 95%;
          border-top: 1px solid #5A5A5A;
          padding-top: 1.6vw;
          margin-left: 2vw;
        }
        img{
          margin-left: 2vw;
          margin-right:3vw;
          transition: all 0.2s linear;
        }
        .tipLine1{
          height: 1px;
          background-color: #F6D9AA;
          width: 30%;
        }
      }
      .detailBoxTip1Extend{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 2.77vw;
        color: #F6D9AA;
        //border-top: 1px solid #5A5A5A;
        //padding-top: 2vw;
        .tipLine{
          height: 1px;
          background-color: #F6D9AA;
          width: 30%;
        }
        .expandText{
          margin-left:3vw;
        }
        img{
          margin-left: 2vw;
          margin-right:3vw;
          transform: rotate(180deg);
          transition: all 0.2s linear;

        }
        .tipLine1{
          height: 1px;
          background-color: #F6D9AA;
          width: 30%;
        }
      }
      .lableRow{
        margin-left: 3vw;
        font-size: 3.611vw;
        display: flex;
        .label{
          color: rgb(121,121,121);
          width: 29.72vw;
          font-weight: bold;
        }
        .value{
          margin-left: 2vw;
          color: #fff;
        }
      }
    }

    .expandBox{
      height: 95vw;
      //border: 1px solid red;
      overflow-y: hidden;
      transition: height 0.1s linear;
      .questionTip{
        margin-top: 4vw;
        margin-bottom: 2vw;
        font-size: 3.611vw;
        color: #F0D4A6;
        //border: 1px solid red;
        width: 91.077vw;
      }
      .maxInputNum{
        color: #fff;
        font-size: 3.472vw;
        position: absolute;
        right: 1vw;
        top: 3vw;
      }
      .problemInput{
        width: 91.077vw;
        height: 10vw;
        border-radius: 1vw;
        border: 1px solid #867860;
        color: #fff;
        padding-right: 11vw;
        padding-left: 2vw;
      }
      .problemInputNone{
        width: 91.077vw;
        height: 10vw;
        border-radius: 1vw;
        border: 1px solid #867860;
        color: #F6D9AA;
        padding-right: 11vw;
        padding-left: 2vw;
      }
      .fileTip{
        width: 91.077vw;
        color: #B7B7B7;
        font-size: 3.055vw;
        //margin: 2vw 0vw;
        margin-bottom: 2vw;
      }
      .fileBox{
        width: 91.077vw;
        height: 30.277vw;
        border: 1px solid #867860;
        border-radius: 1.166vw;
        overflow: hidden;
      }
    }
    .expandBoxExtend{
      height: 0vw;
      //border: 1px solid red;
      overflow-y: hidden;
      transition: all 0.2s linear;
      .questionTip{
        margin-top: 4vw;
        margin-bottom: 2vw;
        font-size: 3.611vw;
        color: #F0D4A6;
        //border: 1px solid red;
        width: 91.077vw;
      }
      .maxInputNum{
        color: #fff;
        font-size: 3.472vw;
        position: absolute;
        right: 1vw;
        top: 3vw;
      }
      .problemInput{
        width: 91.077vw;
        height: 10vw;
        border-radius: 1vw;
        border: 1px solid #867860;
        color: #fff;
        padding-right: 11vw;
        padding-left: 2vw;
      }
      .fileTip{
        width: 91.077vw;
        color: #B7B7B7;
        font-size: 3.055vw;
        //margin: 2vw 0vw;
        margin-bottom: 2vw;
      }
      .fileBox{
        width: 91.077vw;
        height: 30.277vw;
        border: 1px solid #867860;
        border-radius: 1.166vw;
      }
    }
    .btnBox{
      height: 20vw;
      //border: 1px solid red;
      display: flex;
      justify-content: center;
      align-items: center;
      .next{
        display: flex;
        justify-content: center;
        align-items: center;
        //background-color: #404040;
        background-color: #F6D9AA;
        color: #000;
        font-size: 4.166vw;
        width: 87.761vw;
        height: 11.111vw;
        border-radius: 1.11vw;
      }
      .nextNo{
        display: flex;
        justify-content: center;
        align-items: center;
        //background-color: #404040;
        background-color: #4F4F4F;
        color: #9a9a9a;
        font-size: 4.166vw;
        width: 87.761vw;
        height: 11.111vw;
        border-radius: 1.11vw;
      }
    }
    .chatBox{
      width: 100%;
      height: 59.5vh;
      //border: 1px solid red;
      padding: 0 3vw;
      display: flex;
      flex-direction: column;
      overflow-y: hidden;
      flex: none;
      padding-bottom: 5vw;
      overflow-x: hidden;
      .ProofResult{
        display: flex;
        align-items: center;
        width: 91vw;
        height: 17.22vw;
        background-color: rgb(39,39,39);
        position: relative;
        left: 1vw;
        border-radius: 2vw;
        //border: 1px solid red;
        flex: none;
        margin-bottom: 2vw;
        .resultIcon{
          height: 10.27vw;
          width: 10.27vw;
          margin-left: 3vw;
          //border: 1px solid;

        }
        .titleBox{
          width: 70vw;
          //border: 1px solid;
          margin-left: 2vw;
          display: flex;
          flex-direction: column;
          .title{
            font-weight: 700;
            color: #fff;
            font-size: 3.888vw;
          }
          .time{
            color: #DBDBDB;
            font-size: 3.333vw;
          }
        }
        .goIcon{
          height: 4.44vw;
          width: 2.708vw;
          margin-left: 1vw;
        }
      }
      .chatList{
        flex: 1;
        //border: 1px solid green;
        overflow-y: auto;
        padding-top: 2vw;
        display: flex;
        flex-direction: column;
        transition: all 0.2s linear;
        overflow-x: hidden;
        .chatLeft > div{
          display: flex;
          //align-items: center;
          //border: 1px solid yellow;
          padding: 2vw;
          .userImage{
            border-radius: 50vw;
            height: 8.597vw;
            width:8.597vw;
            //border: 1px solid red;
          }
          .userInfo{
            display: flex;
            flex-direction: column;
            margin-left: 1vw;
            position: relative;
            top: -2vw;
            .userName{
              color: #FFFFFF;
              font-weight: 700;
              font-size: 3.333vw;
              position: relative;
              top: 3vw;
            }
            .userContent{
              margin-top: 3vw;
              max-width: 70vw;
              box-sizing: border-box;
              //border: 1px solid red;
              color: #FFFFFF;
              font-weight: 700;
              font-size: 3.333vw;
              background-color: #353534;
              border-radius: 0vw 2vw 2vw 2vw;
              word-break: break-all;
              padding: 2.5vw;
              position: relative;
              top: 2vw;
              line-height: 5vw;
              .fileMessage{
                display: flex;
                align-items: center;
              }
              .fileName {
                font-size: 3.888vw;
                max-width: 42vw;
                text-align: right;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding-right: 1vw;
              }
              .fileIcon {
                height: 14.72vw;
                width: 14.72vw;
              }
              img{
                max-width: 65vw;
              }
            }
          }
        }
        .chatRight > div{
          display: flex;
          //align-items: center;
          //border: 1px solid yellow;
          padding: 2vw;
          justify-content: right;
          .userImage{
            border-radius: 50vw;
            height: 8.597vw;
            width: 8.597vw;
            //border: 1px solid red;
          }
          .userInfo{
            display: flex;
            flex-direction: column;

            margin-right: 1vw;
            //border: 1px solid red;
            position: relative;
            top: -2vw;
            .userName{
              color: #FFFFFF;
              font-weight: 700;
              font-size: 3.333vw;
              position: relative;
              top: 2.5vw;
              text-align: right;
            }
            .userContent{
              margin-top: 3vw;
              max-width: 70vw;
              box-sizing: border-box;
              //border: 1px solid red;
              color: #FFFFFF;
              font-weight: 700;
              font-size: 3.333vw;
              background-color: rgb(59,53,42);
              border-radius: 2vw 0vw 2vw 2vw;
              word-break: break-all;
              padding: 2.5vw;
              position: relative;
              top: 2vw;
              line-height: 5vw;
              .fileMessage{
                display: flex;
                align-items: center;
              }
              .fileName {
                font-size: 3.888vw;
                max-width: 42vw;
                text-align: right;
                margin-right: 1vw;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .fileIcon {
                height: 14.72vw;
                width: 14.72vw;
              }
              img{
                max-width: 65vw;
              }

            }
          }
        }
      }
      .chatActionBox{

        .chatTodoBox{
          position: relative;
          height: 43.888vw;
          height: 43.888vw;
          width: 100%;
          //visibility: hidden;
          //background-color: green;
        }
        .chatTodoBox2{
          position: relative;

          height: 18.338vw;
          width: 100%;
          //visibility: hidden;
          //background-color: green;
        }
        .chatTodo{
          //border: 1px solid red;
          position: fixed;
          height: 43.888vw;
          width: 100%;
          background-color: rgb(34,34,34);
          //z-index: ;
          left: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;
          //align-items: center;
          transition: height 0.1s linear;
          .row{
            display: flex;
            .addFile{
              margin-left: 4vw;
              height: 7.77vw;
              width: 7.77vw;
              margin-top: 3vw;
            }
            .chatInputBox{
              display: flex;
              align-items: center;
              margin-left: 2vw;
              width: 80.538vw;
              background-color: #fff;
              width: 80.538vw;
              height: 10vw;
              border-radius: 9.722vw;
              margin-top: 3vw;
              .chatInput{
                flex: 1;
                height: 100%;
                //border: 1px solid red;
                padding-left: 4vw;
              }
              .sendBtn{
                background-color: #F23042;
                border-radius: 9.722vw;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 18.055vw;
                height: 7.28vw;
                font-size: 3.055vw;
                color: #fff;
                font-weight: 700;
                margin-left: 2vw;
                margin-right: 2vw;
              }
            }
          }
          .fileSelectBox{
            height: 24.55vw;
            width: 100%;
            //border: 1px solid red;
            display: flex;
            padding-top: 4vw;
            transition: all 0.2s linear;
            .fileItem{
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-left: 2vw;
              .uploadComponent{
                border: 1px solid red;
                position: absolute;
                width: 16.666vw;
                height: 13.888vw;
                opacity: 0;
              }
              img{
                width: 16.666vw;
                height: 13.888vw;
              }
              .fileLabel{
                margin-top: 2vw;
                color: #AAAAAA;
                font-size: 2.777vw;
                font-weight: 700;
              }
            }
          }
        }
        .chatTodo2{
          //border: 1px solid red;
          position: fixed;
          height: 19.338vw;
          width: 100%;
          background-color: rgb(34,34,34);
          //z-index: ;
          left: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;
          //align-items: center;
          transition: height 0.1s linear;
          .row{
            display: flex;
            .addFile{
              margin-left: 4vw;
              height: 7.77vw;
              width: 7.77vw;
              margin-top: 5vw;
            }
            .chatInputBox{
              display: flex;
              align-items: center;
              margin-left: 2vw;
              width: 80.538vw;
              background-color: #fff;
              width: 80.538vw;
              height: 10vw;
              border-radius: 9.722vw;
              margin-top: 4vw;
              .chatInput{
                flex: 1;
                height: 100%;
                //border: 1px solid red;
                padding-left: 4vw;
              }
              .sendBtn{
                background-color: #F23042;
                border-radius: 9.722vw;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 18.055vw;
                height: 7.28vw;
                font-size: 3.055vw;
                color: #fff;
                font-weight: 700;
                margin-left: 2vw;
                margin-right: 2vw;
              }
            }
          }
          .fileSelectBox {
           display: none;
          }
        }
      }

    }
  }
  .messageMarsk{
    position: absolute;
    top: -19vw;
    z-index: 5;
    height: 100vh;
    width: 100%;
    background: rgba(0,0,0,.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .messageBox{
      width: 86.66vw;
      height: 72.22vw;
      background: rgb(25,26,25);
      border-radius: 4.16vw;
      border: 1px solid #737373;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title{
        color:#D9D9D9;
        font-size: 4.72vw;
        font-weight: 700;
        position: relative;
        top: 10vw;
      }
      .content{
        //border: 1px solid red;
        color: #fff;
        font-size: 3.75vw;
        position: absolute;
        left: 8vw;
        top: 28vw;
        line-height: 7vw;
      }
      .actionBtnBox{
        position: relative;
        top: 18vw;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 60vw;
        //border: 1px solid red;
        .btn{
          background-color:#F1DAB0;
          color: #000000;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 67.05vw;
          height: 9.436vw;
          border-radius: 1.388vw;
        }
      }
      .returnTip{
        color: #F0D7AE;
        font-size: 2.916vw;
        line-height: 4vw;
      }
      .closeIcon{
        position: absolute;
        left: 42.5vw;
        top: 75vw;
      }
    }
  }
}
.formErrorTip {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 3.472vw;
  color: #9D0000;
  margin-top: 1.388vw;
  padding-left: 1.094vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/workOrderReview/UploadproofDepositDetail.vue